import resolveOptimizedImage from "@/Helpers/resolveOptimizedImage";
import { PodcastBlockProps } from "@/types/components/PodcastBlockProps";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "@inertiajs/react";

const PatientPodcastBlock = ({ image, title, createdAt, length = '', link, is_pin_protected = false }: {
    image: string;
    createdAt: string;
    title: string;
    length?: string;
    link: string;
    is_pin_protected?: boolean;
}) => {
    const resolveExtension = (file: string): string => {
        return file.replace(/(\/images\/[^.]+)\.[a-z]+/i, "$1.webp");
    }

    return (
        <div className="podcast-card text-left">
            <Link as="button" href={link} title={`Odsłuchaj podcast ${title}`} className="w-full h-auto block">
                <img src={resolveExtension(image)} className="object-cover rounded-2xl aspect-square h-auto w-full" />
            </Link>
            <div>
                <div className="flex items-center gap-x-2 justify-between">
                    <div className="w-[calc(100%-48px)]">
                        <p className="text-accordorange tracking-[0.24px] font-semibold mt-2">Dodano {createdAt}</p>
                        <p className="text-arcticMist text-body tracking-[0.27px] font-semibold">{title}</p>
                        <div className="flex items-center justify-between mt-2">
                            {!!length &&
                                <div className="flex items-center gap-x-2">
                                    <Icon icon={`fa6-solid:headphones`} width={16} className="text-accordorange" />
                                    <p className="text-accordorange tracking-[0.24px] font-semibold">{length}</p>
                                </div>
                            }
                        </div>
                    </div>
                    {!!is_pin_protected && <div className="size-10 bg-accordorange rounded-full flex items-center justify-center"><Icon icon={`ph:lock-key`} className="text-arcticMist origin-bottom animate-lock-wiggle-loop" width={24} /></div>}

                </div>
            </div>
        </div>
    )
}

export default PatientPodcastBlock;